import { QUESTIONS_ROUTES } from '../../constants/_routes'
import questionsTypes from '../../constants/questionsTypes'
import { axios } from '../../services'

// INDEX
const questions_csv_request = () => {
  return {
    type: questionsTypes.csv.request
  }
}

const questions_csv_success = () => {
  return {
    type: questionsTypes.csv.success
  }
}

const questions_csv_failure = (messages) => {
  return {
    type: questionsTypes.csv.failure,
    payload: messages
  }
}

const questions_csv = (filters={}, sort="", order="") => {
  return function (dispatch) {
    // Before Request
    dispatch(questions_csv_request())

    axios.get(
      `${QUESTIONS_ROUTES.index}.csv`,
      {
        params: {
          sort: sort,
          order: order,
          filters: filters
        },
        responseType: 'blob'
      }
    ).then( response => {
      // success
      const blob = URL.createObjectURL(response.data, "mitsos")
      // console.log("blob")
      // console.log(blob)
      let fileLink = document.createElement('a')
      document.body.appendChild(fileLink);
      fileLink.style="display: none"
      fileLink.href = blob
      fileLink.download = "questions.csv"
      fileLink.click();
      URL.revokeObjectURL(blob)
      dispatch( questions_csv_success() )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching csv file."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( questions_csv_failure(errors))
    })
  }

}

export {
  questions_csv
}



// WEBPACK FOOTER //
// ./src/js/actions/questions/getcsv.js